import { combineReducers } from '@reduxjs/toolkit';
import { plantDesignDeclarationReducer } from 'plantDesign/redux/designDeclarationSlice';
import { plantDesignApplicantDetailsReducer } from 'plantDesign/redux/plantDesignApplicantDetailsSlice';
import { plantDesignApplicationReducer } from 'plantDesign/redux/plantDesignDesignApplicationSlice';
import { plantDesignDesignerVerifierReducer } from 'plantDesign/redux/plantDesignDesignerVerifierSlice';
import { plantDesignDrawingAndTechReducer } from 'plantDesign/redux/plantDesignDrawingAndTechSlice';
import { plantDesignFeesReducer } from 'plantDesign/redux/plantDesignFeesSlice';
import { plantDesignLicenceTypesReducer } from 'plantDesign/redux/plantDesignLicenceTypesSlice';
import { plantDesignPaymentReducer } from 'plantDesign/redux/plantDesignPaymentSlice';
import { plantDesignPdfLinkReducer } from 'plantDesign/redux/plantDesignPdfLinkSlice';
import { plantDesignReferenceDataReducer } from 'plantDesign/redux/plantDesignReferenceDataSlice';
import { plantDesignRegistrationHolderReducer } from 'plantDesign/redux/plantDesignRegistrationHolderSlice';
import { plantDesignReducer } from 'plantDesign/redux/plantDesignSlice';
import { plantItemsReducer } from 'plantItemNew/redux/reducers/plantItems';
import { applicantDetailsReducer } from 'plantItemNew/redux/slices/applicantDetailsSlice';
import { declarationReducer } from 'plantItemNew/redux/slices/declarationSlice';
import { feesReducer } from 'plantItemNew/redux/slices/feesSlice';
import { formReducer } from 'plantItemNew/redux/slices/formSlice';
import { passwordLessOidcReducer } from 'shared/redux/passwordlessOidcSlice';
import { paymentReducer } from 'plantItemNew/redux/slices/paymentSlice';
import { pdfLinkReducer } from 'plantItemNew/redux/slices/pdfLinkSlice';
import { plantItemLicenceTypesReducer } from 'plantItemNew/redux/slices/plantItemLicenceTypesSlice';
import { referenceDataReducer } from 'plantItemNew/redux/slices/referenceDataSlice';
import { plantItemRenewalApplicantDetailsReducer } from 'plantItemRenewal/redux/plantItemRenewalApplicantDetailsSlice';
import { plantItemRenewalDeclarationReducer } from 'plantItemRenewal/redux/plantItemRenewalDeclarationSlice';
import { plantItemRenewalFeesReducer } from 'plantItemRenewal/redux/plantItemRenewalFeesSlice';
import { plantItemRenewalPaymentReducer } from 'plantItemRenewal/redux/plantItemRenewalPaymentSlice';
import { renewalItemsReducer } from 'plantItemRenewal/redux/renewalItemsSlice';
import { applicationReducer } from './applicationSlice';
import { holderDetailsReducer } from 'plantItemNew/redux/slices/holderDetailsSlice';

const rootReducer = combineReducers({
  plantItemLicenceTypes: plantItemLicenceTypesReducer,
  application: applicationReducer,
  form: formReducer,
  applicantDetails: applicantDetailsReducer,
  holderDetails: holderDetailsReducer,
  plantItems: plantItemsReducer,
  fees: feesReducer,
  payment: paymentReducer,
  referenceData: referenceDataReducer,
  pdfLink: pdfLinkReducer,
  declaration: declarationReducer,

  plantDesignLicenceTypes: plantDesignLicenceTypesReducer,
  plantDesignApplication: plantDesignApplicationReducer,
  plantDesignReferenceData: plantDesignReferenceDataReducer,
  plantDesignApplicantDetails: plantDesignApplicantDetailsReducer,
  plantDesign: plantDesignReducer,
  plantDesignDrawingAndTech: plantDesignDrawingAndTechReducer,
  plantDesignVerifier: plantDesignDesignerVerifierReducer,
  plantDesignDeclaration: plantDesignDeclarationReducer,
  plantDesignFees: plantDesignFeesReducer,
  plantDesignPayment: plantDesignPaymentReducer,
  plantDesignPdfLink: plantDesignPdfLinkReducer,
  passwordlessOidc: passwordLessOidcReducer,
  plantDesignHolderDetails: plantDesignRegistrationHolderReducer,

  plantItemRenewalApplicantDetails: plantItemRenewalApplicantDetailsReducer,
  plantItemRenewalDeclaration: plantItemRenewalDeclarationReducer,
  plantItemRenewalFees: plantItemRenewalFeesReducer,
  plantItemRenewalPayment: plantItemRenewalPaymentReducer,
  renewalItems: renewalItemsReducer,
});

export default rootReducer;
